import React from 'react';
import { Modal } from 'react-bootstrap';
import useGlobalStore from "../../hooks/useGlobalStore";
import { useNavigate } from 'react-router-dom';


const PayrollModal = (props) => {
  const navigator = useNavigate()
  const { TOGGLE_PAYROLL_MODAL, toggleForModal } = useGlobalStore();

  const handleClose = () => {
    toggleForModal('TOGGLE_PAYROLL_MODAL')
    props.stopAll()
  }//dispatch({ type: 'TOGGLE_PAYROLL_MODAL' });
  const handleNotClose = () => console.log("Not Close Modal")


  return (
    <div>
      <Modal show={TOGGLE_PAYROLL_MODAL} onHide={handleNotClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered scrollable className="customModal1 termsCondition__modal"
      >
        <Modal.Header>
          <button type="button" className="customModal1-close" onClick={handleClose}>
            <img src="/images/modaclosebtn.svg" alt="" />
          </button>
        </Modal.Header>
        <Modal.Body>
          {/* start: show paywall modal */}
          <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-6 z-50"
            style={{ opacity: 1 }}
          >
            <div
              className="bg-card rounded-3xl shadow-2xl p-8 max-w-sm w-full relative"
              style={{ transform: "none" }}
            >
              <button className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
                onClick={handleClose}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-x w-6 h-6"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#d7428c"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-lock w-8 h-8 text-primary"
                >
                  <rect width={18} height={11} x={3} y={11} rx={2} ry={2} />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-3 text-center">
                Spend more time with {props.name}
              </h3>
              <p className="text-foreground/70 mb-6 text-center">
                Unlock full access to unlimited messages, voice calls, and exclusive
                content
              </p>
              <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full mb-3"
                onClick={() => {
                  // props.stopAll()
                  toggleForModal('TOGGLE_PAYROLL_MODAL')
                  setInterval(() => {
                    navigator('/user/subscription-plans')
                  }, 300)

                }}
              >
                Unlock Full Access
              </button>
              <button className="w-full text-sm text-muted-foreground hover:text-foreground transition-colors"
                onClick={handleClose}
              >
                Maybe later
              </button>
            </div>
          </div>

          {/* end: show paywall modal */}

        </Modal.Body>
        {/* <Modal.Footer>
          <button type="button" className="themeBtnBlue" onClick={handleClose}>Read It</button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default PayrollModal;